import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "md-editor-outter-container flex-center" };
var _hoisted_2 = { class: "note-draft-tip" };
var _hoisted_3 = { class: "note-md-options-container" };
var _hoisted_4 = { class: "note-md-options-inner-container" };
var _hoisted_5 = { class: "create-notelink-container" };
var _hoisted_6 = { class: "modal-footer" };
import { onBeforeUnmount, onMounted, ref, watch, computed, render, h, } from "vue";
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";
import { useStore } from "@/store";
import { MdEditor, config, } from "md-editor-v3";
import CustomSVG from "@/components/custom/CustomSVG.vue";
import PhraseSelectModal from "@/components/MdEditAbout/PhraseSelectModal.vue";
import "md-editor-v3/lib/style.css"; // MD 引入样式，否则主题无效!!!!!!!>sp
import { phraseTypes, processMdContent } from "@/utils/phrase";
// import funcs from "@/commonFunctions";
import api from "@/utils/api";
import tools from "@/utils/tools";
var mdContentSaveToggleTime = 1000; // 草稿内容保存定时，3.5s 保存一次（随记加快，1s一次）
export default /*@__PURE__*/ _defineComponent({
    __name: 'NoteMdEditor',
    setup: function (__props) {
        var _this = this;
        window.resourceBaseUrl = "https://".concat(window.location.host, "/notedraft");
        /// /modifydraftmeta
        var mdEditorRef = ref();
        var store = useStore();
        var route = useRoute();
        var router = useRouter();
        var isShowPhraseModal = ref(false), phraseType = ref(phraseTypes[0].value), selectedPhrase = ref(null);
        var mdContent = ref("");
        var notelinks = ref([]);
        // const notelinksShowComputed = computed(() => {
        //   return notelinks.value.map((item) => item.describe);
        // });
        var notelinksShowComputed = computed({
            get: function () { return notelinks.value.map(function (item) { return item.describe; }); },
            set: function (newTags) {
                notelinks.value = notelinks.value.filter(function (item) {
                    return newTags.includes(item.describe);
                });
            },
        });
        var isShowCreateNotelinkModal = ref(false);
        var modalInputNotelinkDescribe = ref(""), modalInputNotelinkHref = ref("");
        var mdContentSaveToggleTimer = undefined;
        var isJustResetNoteDraft = false; // 是否刚刚重置草稿，避免重置 notelinks 时触发 watch 事件
        var isNoteDraftTagLoaded = ref(false); // 草稿所属 ID 是否加载完成
        var isDraftAlreadyRelease = false; // 是否已发布草稿，用于确保在发布导致该页面卸载时不会再次保存已经发布的草稿
        store.setPageName("随记编辑");
        api.requestBaseWithMask
            .get("/notedraft/notelinks.json?t=".concat(Date.now()))
            .then(function (res) {
            notelinks.value = res.data;
            watch(notelinks, function (newVal) {
                if (isJustResetNoteDraft) {
                    isJustResetNoteDraft = false; // 重置草稿后，设置为 false
                    return;
                }
                clearInterval(mdContentSaveToggleTimer); // 清除本次修改触发的自动保存定时器，本次修改已启用手动保存
                mdContentSaveToggleTimer = undefined;
                saveContent();
            }, { deep: true });
        })
            .catch(function (error) {
            window.$notifyError("获取草稿附带链接失败", error.response.msg);
        });
        api.requestBaseWithMask
            .get("/notedraft/markdown.md?t=".concat(Date.now()))
            .then(function (res) {
            // dos 系统（windows）换行符为 \r\n，统一改为 linux 系统换行符为 \n，否则会报错
            mdContent.value = String(res.data).replace(/\r\n/g, "\n");
            watch(function () { return mdContent.value; }, function (newVal) {
                isDraftAlreadyRelease = false; // 修改草稿后，设置为 false
                clearTimeout(mdContentSaveToggleTimer);
                mdContentSaveToggleTimer = setTimeout(function () {
                    saveContent();
                    clearTimeout(mdContentSaveToggleTimer);
                }, mdContentSaveToggleTime);
            });
        })
            .catch(function (error) {
            window.$notifyError("获取草稿正文失败", error.response.msg);
        });
        var draftRefID = ref(-1);
        api.request
            .get("/getnotedraftfrom")
            .then(function (res) {
            draftRefID.value = res.data;
        })
            .catch(function (error) {
            window.$notifyError("获取草稿引用 ID 失败", error.response.msg);
        })
            .finally(function () {
            isNoteDraftTagLoaded.value = true;
        });
        var mdEditorContainer = ref(undefined);
        config({
            markdownItPlugins: function (plugins) {
                return plugins.filter(function (p) { return p.type !== "xss"; });
            },
        });
        var mdHeadingId = function (text, _level, index) {
            return "heading-".concat(text, "-").concat(index);
        };
        var uploadIMG = function (files, callback) { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(files.map(function (file) {
                            return new Promise(function (rev, rej) {
                                var form = new FormData();
                                form.append("file", file);
                                api.requestWithSmallLoad
                                    .quickPost("/uploadnotefile", form)
                                    .then(function (res) { return rev(res); })
                                    .catch(function (error) {
                                    window.$notifyError("上传图片失败", error);
                                    rej(res);
                                });
                            });
                        }))];
                    case 1:
                        res = _a.sent();
                        callback(res
                            .filter(function (item) {
                            console.log("callback filter", item);
                            var resp = item;
                            if (resp.code !== 0) {
                                window.$msgError("上传图片失败: " + resp.msg);
                            }
                            return resp.code === 0;
                        })
                            ///////////////////////////////////////////////////////////////////////////////////////////////////
                            .map(function (item) {
                            // 文件名有可能被修改（在存在重名文件时），使用服务器返回的文件名
                            return "\n\uFFE5\uFFE5\\/RESOURCE_BASE\\/\uFFE5\uFFE5/".concat(encodeURIComponent(item.data), "\n");
                        }));
                        return [2 /*return*/];
                }
            });
        }); };
        var handleCreateNotelink = function () {
            if (modalInputNotelinkDescribe.value.length === 0 ||
                modalInputNotelinkHref.value.length === 0) {
                window.$notifyError("信息缺失", "描述和链接不能为空");
                return;
            }
            notelinks.value.push({
                noteLinkId: Math.floor(Math.random() * 10000000),
                describe: modalInputNotelinkDescribe.value,
                href: modalInputNotelinkHref.value,
            });
            modalInputNotelinkDescribe.value = "";
            modalInputNotelinkHref.value = "";
            isShowCreateNotelinkModal.value = false;
        };
        var activeCreateNotelinkModal = function () {
            modalInputNotelinkDescribe.value = "";
            modalInputNotelinkHref.value = "";
            isShowCreateNotelinkModal.value = true;
        };
        function saveContent(isNeedMask) {
            if (isNeedMask === void 0) { isNeedMask = false; }
            return __awaiter(this, void 0, void 0, function () {
                var requestFunc, formData;
                return __generator(this, function (_a) {
                    requestFunc = isNeedMask ? api.request : api.requestWithSmallLoad;
                    formData = new FormData();
                    formData.append("content", mdContent.value.replaceAll(/\r\n/g, "\n"));
                    formData.append("notelink", JSON.stringify(notelinks.value));
                    return [2 /*return*/, requestFunc
                            .quickPost("/savenotedraft", formData)
                            .then(function (res) {
                            return;
                        })
                            .catch(function (error) {
                            console.error(error);
                            window.$msgError("保存草稿失败: " + error.response.msg);
                            // 保存失败可能是seq问题，需要进行刷新
                            tools.reflash();
                        })
                            .catch(function (error) {
                            console.error(error);
                            window.$msgError(error);
                        })];
                });
            });
        }
        // 手动保存，去除自动保存 timer，保证手动保存时不会触发自动保存影响 seq 次序
        var saveDraft = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        clearInterval(mdContentSaveToggleTimer); // 清除本次修改触发的自动保存定时器，本次修改已启用手动保存
                        mdContentSaveToggleTimer = undefined;
                        return [4 /*yield*/, saveContent(true)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        // 文章内容，notelinks
        var resetLocalNoteDraft = function () {
            isJustResetNoteDraft = true; // 避免触发 notelinks 的 watch 事件
            mdContent.value = "";
            notelinks.value = [];
            isDraftAlreadyRelease = false; // 重置草稿后，设置为 false
            draftRefID.value = -1; // 重置草稿 ID
            // 清除定时器
            clearTimeout(mdContentSaveToggleTimer);
            mdContentSaveToggleTimer = undefined;
        };
        var requestResetNoteDraft = function () {
            api.request
                .get("/resetnotedraft")
                .then(function (res) {
                window.$notifySuccess("重置草稿成功", "草稿已重置");
                resetLocalNoteDraft();
            })
                .catch(function (error) {
                console.error(error);
                window.$notifyError("重置草稿失败", error.response.msg);
            });
        };
        var releasePost = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, saveDraft()];
                    case 1:
                        _a.sent();
                        api.request
                            .quickPost("/releasenote", new FormData())
                            .then(function (res) {
                            window.$notifySuccess("发布草稿成功", "\u968F\u8BB0\u8349\u7A3F\u5DF2\u53D1\u5E03\u3002\u53D1\u5E03\u65F6\u95F4\uFF1A".concat(new Date().toLocaleString()));
                            isDraftAlreadyRelease = true; // 发布成功后设置为 true
                            resetLocalNoteDraft(); // 仅清除本地显示，远程的在发布后已经清除
                        })
                            .catch(function (error) {
                            window.$notifyError("发布草稿失败", error.response.msg);
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        // 第一个参数为传入给 CustomSVG 的 icon 名称，第二个参数为 tooltip 的 title，第三个参数为点击事件
        function addMdEditorToolbarOption(customSVGIconName, title, onClick) {
            var mdToolbars = document.querySelector(".md-editor-toolbar-left");
            if (mdToolbars) {
                var vnode = h(CustomSVG, {
                    icon: customSVGIconName,
                    class: ["lucide", "lucide-save-icon", "md-editor-icon"],
                });
                var container = document.createElement("div");
                container.className = "md-editor-toolbar-item";
                container.title = title;
                container.onclick = onClick;
                render(vnode, container); // 将 h 的 vnode 渲染到 container
                mdToolbars.appendChild(container);
            }
        }
        var insertTextToEditor = function (text) {
            if (mdEditorRef.value) {
                mdEditorRef.value.insert(function (_) {
                    return {
                        targetValue: text,
                        select: false,
                        deviationStart: 0,
                        deviationEnd: 0,
                    };
                });
            }
        };
        onMounted(function () {
            // // 测试用
            // // 阻止页面刷新
            // window.addEventListener("beforeunload", (event) => {
            //   event.preventDefault();
            //   event.returnValue = "";
            // });
            addMdEditorToolbarOption("QuickEdit", "快捷输入", function () {
                isShowPhraseModal.value = true;
            });
            // 上传文件
            function uploadNoteFile(file) {
                var formData = new FormData();
                formData.append("file", file);
                api.request
                    .quickPost("/uploadnotefile", formData)
                    .then(function (res) {
                    var resp = res;
                    window.$notifySuccess("上传文件成功", "\u6587\u4EF6\u5DF2\u4E0A\u4F20\u3002\u6587\u4EF6\u540D\uFF1A".concat(resp.data));
                    insertTextToEditor("\n\uFFE5\uFFE5\\/RESOURCE_BASE\\/\uFFE5\uFFE5/".concat(encodeURIComponent(resp.data), "\n"));
                })
                    .catch(function (error) {
                    window.$notifyError("上传文件失败", error);
                });
            }
            // 触发选择文件的 input 标签，仅取其功能，不需要挂载到 DOM 上
            var uploadFileInput = document.createElement("input");
            uploadFileInput.type = "file";
            uploadFileInput.oninput = function (e) { return __awaiter(_this, void 0, void 0, function () {
                var target, files;
                return __generator(this, function (_a) {
                    target = e.target;
                    files = target.files;
                    if (!files || files.length === 0)
                        return [2 /*return*/];
                    if (files.length === 1) {
                        // 单个文件，直接上传
                        uploadNoteFile(files[0]);
                        return [2 /*return*/];
                    }
                    else {
                        window.$notifyError("文件数量错误", "仅允许最多一个文件上传");
                    }
                    return [2 /*return*/];
                });
            }); };
            addMdEditorToolbarOption("FileUpload", "上传文件", function () {
                uploadFileInput.click();
            });
        });
        onBeforeUnmount(function () {
            // 清除定时器
            clearTimeout(mdContentSaveToggleTimer);
            if (!isDraftAlreadyRelease)
                saveDraft();
        });
        var editorOnSave = function (v, h) {
            saveDraft();
        };
        var editorOnError = function (e) {
            console.error("editor error", e);
            window.$notifyError("\u7F16\u8F91\u5668\u5185\u90E8\u9519\u8BEF: ".concat(e.name), e.message);
        };
        var handlePhraseConfirm = function (phrase) {
            if (mdEditorRef.value) {
                mdEditorRef.value.insert(function (_) {
                    /**
                     * @return targetValue    待插入内容
                     * @return select         插入后是否自动选中内容，默认：true
                     * @return deviationStart 插入后选中内容鼠标开始位置，默认：0
                     * @return deviationEnd   插入后选中内容鼠标结束位置，默认：0
                     */
                    return {
                        targetValue: "".concat(phrase),
                        select: false,
                        deviationStart: 0,
                        deviationEnd: 0,
                    };
                });
            }
        };
        return function (_ctx, _cache) {
            var _component_n_icon = _resolveComponent("n-icon");
            var _component_n_button = _resolveComponent("n-button");
            var _component_n_dynamic_tags = _resolveComponent("n-dynamic-tags");
            var _component_n_input = _resolveComponent("n-input");
            var _component_n_card = _resolveComponent("n-card");
            var _component_n_modal = _resolveComponent("n-modal");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", {
                        class: "md-editor-container flex-center",
                        ref_key: "mdEditorContainer",
                        ref: mdEditorContainer
                    }, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("span", {
                                class: _normalizeClass([
                                    'note-draft-tip-content',
                                    draftRefID.value !== -1
                                        ? 'note-draft-tip-exists'
                                        : 'note-draft-tip-not-exists',
                                    isNoteDraftTagLoaded.value
                                        ? 'note-draft-tip-loaded'
                                        : 'note-draft-tip-not-loaded',
                                ])
                            }, _toDisplayString(draftRefID.value !== -1
                                ? "\u8349\u7A3F\u5DF2\u5B58\u5728\uFF0C\u968F\u8BB0\u8349\u7A3F ID\uFF1A".concat(draftRefID.value)
                                : "新建的随机草稿"), 3)
                        ]),
                        _createVNode(_unref(MdEditor), {
                            class: "md-editor",
                            modelValue: mdContent.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((mdContent).value = $event); }),
                            onUploadImg: uploadIMG,
                            onOnSave: editorOnSave,
                            onOnError: editorOnError,
                            "process-content": _unref(processMdContent),
                            theme: _unref(store).isDarkTheme ? 'dark' : 'light',
                            autoFoldThreshold: 80,
                            placeholder: "创造从此刻开始...",
                            toolbarsExclude: ['github'],
                            ref_key: "mdEditorRef",
                            ref: mdEditorRef,
                            mdHeadingId: mdHeadingId
                        }, null, 8, ["modelValue", "process-content", "theme"])
                    ], 512),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_n_dynamic_tags, {
                                value: notelinksShowComputed.value,
                                "onUpdate:value": _cache[1] || (_cache[1] = function ($event) { return ((notelinksShowComputed).value = $event); })
                            }, {
                                trigger: _withCtx(function (_a) {
                                    var activate = _a.activate, disabled = _a.disabled;
                                    return [
                                        _createVNode(_component_n_button, {
                                            size: "small",
                                            type: "primary",
                                            dashed: "",
                                            disabled: disabled,
                                            onClick: activeCreateNotelinkModal
                                        }, {
                                            icon: _withCtx(function () { return [
                                                _createVNode(_component_n_icon, null, {
                                                    default: _withCtx(function () { return [
                                                        _createVNode(CustomSVG, { icon: "AddBold" })
                                                    ]; }),
                                                    _: 1
                                                })
                                            ]; }),
                                            default: _withCtx(function () { return [
                                                _cache[10] || (_cache[10] = _createTextVNode(" 添加 "))
                                            ]; }),
                                            _: 2
                                        }, 1032, ["disabled"])
                                    ];
                                }),
                                _: 1
                            }, 8, ["value"]),
                            _createVNode(_component_n_button, {
                                onClick: requestResetNoteDraft,
                                style: { "background-color": "var(--card-bg)" }
                            }, {
                                default: _withCtx(function () { return _cache[11] || (_cache[11] = [
                                    _createTextVNode(" 重置草稿 ")
                                ]); }),
                                _: 1
                            }),
                            _createVNode(_component_n_button, {
                                type: "primary",
                                onClick: releasePost
                            }, {
                                default: _withCtx(function () { return _cache[12] || (_cache[12] = [
                                    _createTextVNode("发布")
                                ]); }),
                                _: 1
                            })
                        ])
                    ])
                ]),
                _createVNode(_component_n_modal, {
                    show: isShowCreateNotelinkModal.value,
                    "onUpdate:show": _cache[6] || (_cache[6] = function ($event) { return ((isShowCreateNotelinkModal).value = $event); })
                }, {
                    default: _withCtx(function () { return [
                        _createVNode(_component_n_card, {
                            style: { "width": "600px" },
                            title: "新建随记链接",
                            bordered: false,
                            size: "huge",
                            role: "dialog",
                            "aria-modal": "true"
                        }, {
                            "header-extra": _withCtx(function () { return [
                                _createVNode(_component_n_icon, {
                                    size: "1.6rem",
                                    onClick: _cache[2] || (_cache[2] = function ($event) { return (isShowCreateNotelinkModal.value = false); })
                                }, {
                                    default: _withCtx(function () { return _cache[13] || (_cache[13] = [
                                        _createElementVNode("i", { class: "fa-solid fa-square-xmark fa-close-style" }, null, -1)
                                    ]); }),
                                    _: 1
                                })
                            ]; }),
                            footer: _withCtx(function () { return [
                                _createElementVNode("div", _hoisted_6, [
                                    _createVNode(_component_n_button, {
                                        onClick: _cache[5] || (_cache[5] = function ($event) { return (isShowCreateNotelinkModal.value = false); }),
                                        type: "default",
                                        class: "cancel-button"
                                    }, {
                                        default: _withCtx(function () { return _cache[14] || (_cache[14] = [
                                            _createTextVNode(" 取消 ")
                                        ]); }),
                                        _: 1
                                    }),
                                    _createVNode(_component_n_button, {
                                        onClick: handleCreateNotelink,
                                        type: "primary",
                                        class: "confirm-button"
                                    }, {
                                        default: _withCtx(function () { return _cache[15] || (_cache[15] = [
                                            _createTextVNode(" 确定 ")
                                        ]); }),
                                        _: 1
                                    })
                                ])
                            ]; }),
                            default: _withCtx(function () { return [
                                _createElementVNode("div", _hoisted_5, [
                                    _createVNode(_component_n_input, {
                                        value: modalInputNotelinkDescribe.value,
                                        "onUpdate:value": _cache[3] || (_cache[3] = function ($event) { return ((modalInputNotelinkDescribe).value = $event); }),
                                        placeholder: "请输入描述",
                                        class: "create-notelink-input",
                                        style: { "width": "100%" }
                                    }, null, 8, ["value"]),
                                    _createVNode(_component_n_input, {
                                        value: modalInputNotelinkHref.value,
                                        "onUpdate:value": _cache[4] || (_cache[4] = function ($event) { return ((modalInputNotelinkHref).value = $event); }),
                                        placeholder: "请输入链接（需要完整协议，否则会跳转站内链接，支持动态参数解析）",
                                        class: "create-notelink-input",
                                        style: { "width": "100%" }
                                    }, null, 8, ["value"])
                                ])
                            ]; }),
                            _: 1
                        })
                    ]; }),
                    _: 1
                }, 8, ["show"]),
                _createVNode(PhraseSelectModal, {
                    "is-show-modal": isShowPhraseModal.value,
                    "onUpdate:isShowModal": _cache[7] || (_cache[7] = function ($event) { return ((isShowPhraseModal).value = $event); }),
                    "selected-phrase-type": phraseType.value,
                    "onUpdate:selectedPhraseType": _cache[8] || (_cache[8] = function ($event) { return ((phraseType).value = $event); }),
                    "selected-phrase": selectedPhrase.value,
                    "onUpdate:selectedPhrase": _cache[9] || (_cache[9] = function ($event) { return ((selectedPhrase).value = $event); }),
                    onConfirmSelect: handlePhraseConfirm
                }, null, 8, ["is-show-modal", "selected-phrase-type", "selected-phrase"])
            ], 64));
        };
    }
});
